import {atom} from "jotai"

export const deletingBolsAtom = atom(
  /** @type {{[bol: string]: boolean}} */ ({}),
)
